import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/categories';
import SectionHeader from './SectionHeader';

const tone = ['bg-primary-100 text-primary-700', 'bg-accent-100 text-accent-800', 'bg-secondary-100 text-secondary-900', 'bg-primary-50 text-primary-600', 'bg-secondary-50 text-secondary-700', 'bg-accent-200 text-accent-900'];

export default function Categories() {
  return (
    <section className="section-pad bg-background-50">
      <div className="container-page">
        <SectionHeader
          eyebrow="分门别类"
          title="六大分类，想找哪种笑点都有"
          desc="无论你想看恶搞反转还是脑洞魔性，点进对应分类就能精准开追。"
          linkTo="/category"
          linkLabel="浏览全部分类"
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {comicCategories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group rounded-2xl border border-background-200/70 bg-background-100 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${tone[index % tone.length]}`}>
                <i className={`${cat.icon} text-xl`} aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{cat.name}</h3>
              <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">{cat.description}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-primary-600">
                {cat.count} 部作品
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}